import { render, staticRenderFns } from "./UserMain.vue?vue&type=template&id=d7b479ea&scoped=true&"
import script from "./UserMain.vue?vue&type=script&lang=js&"
export * from "./UserMain.vue?vue&type=script&lang=js&"
import style0 from "./UserMain.vue?vue&type=style&index=0&id=d7b479ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b479ea",
  null
  
)

export default component.exports